/**
 * InfoToast — 짧은 1회성 안내 메시지 토스트 (Shell 전속)
 *
 * 알림·현장요약에서 "웹 코드는 없고 앱 코드만 있는" 항목(=앱 전용 화면)을 클릭했을 때처럼,
 * 화면 이동 없이 짧은 안내만 띄우면 되는 경우에 쓴다. NotificationToast(실제 알림 표시용)와는
 * 다른 목적 — 저장된 알림 목록과 무관한 즉석 텍스트 메시지 전용이라 별도 모듈로 둔다.
 *
 * 스타일은 D-09 §15.8 표준 토스트 클래스(.toast-wrap/.toast, packages/styles/src/components.css)를
 * 그대로 쓴다 — 임의 스타일 금지, 위치·z-index(--z-toast)·elevation 전부 그 클래스가 소유한다.
 */
import { useEffect, useState } from 'react';

let listeners: Array<(message: string | null) => void> = [];
let current: string | null = null;
let hideTimer: ReturnType<typeof setTimeout> | null = null;

const DISPLAY_MS = 4000; // D-09 §15.8 규칙 — 자동 소멸 기본 4초

export function showInfoToast(message: string) {
  current = message;
  listeners.forEach((l) => l(message));
  if (hideTimer) clearTimeout(hideTimer);
  hideTimer = setTimeout(() => {
    current = null;
    listeners.forEach((l) => l(null));
  }, DISPLAY_MS);
}

export function InfoToastViewport() {
  const [message, setMessage] = useState<string | null>(current);

  useEffect(() => {
    listeners.push(setMessage);
    return () => {
      listeners = listeners.filter((l) => l !== setMessage);
    };
  }, []);

  if (!message) return null;

  return (
    <div className="toast-wrap" aria-live="polite">
      <div className="toast info">
        <span>ⓘ</span>
        <span>{message}</span>
      </div>
    </div>
  );
}
